import md5 from 'vux/src/tools/md5/index.js'

export default {
leader_num(data) {
for (var i = 0; i < data.length; ++i) {
if (!data[i].hide) {
return true
}
}
return false
},
isObj(val) {
return Object.prototype.toString.call(val) == "[object Object]";
},
isArr(val) {
return Object.prototype.toString.call(val) == "[object Array]";
},
findIndexOf(list,str) {
for (let i in list) {
if(str.indexOf(list[i]) > - 1){
return true
}
}
return false
},
_isMobile() {
return navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
},
checkTv(url) {
if (!url) return ''
return (url.match(/\.(mp4|rmvb|avi|ts)$/) != null)
},
confirm(that, data) {
let option = {
content: that.$t('sys_confirm'),
onShow() {
that._func.modal_static(1)
},
onHide() {
that._func.modal_static()
}
}
that.$vux.confirm.show(Object.assign(option, data))
},
goBack(that) {
if (that._fromHistory.list.length < 1) {
that.$router.push('/')
return
}
let url = that._fromHistory.list[that._fromHistory.list.length - 1]
that._fromHistory.list.pop()
that._fromHistory.flag = false
that.$router.push(url)
},
isPhonex() {
return /iphone/gi.test(navigator.userAgent) && window.screen.height > 750 ? true : false
},
dataHTML(htmlStr) {
let imgReg = /<img.*?(?:>|\/>)/gi;
let srcReg = /data-src=[\'\"]?([^\'\"]*)[\'\"]?/i;
let arr = htmlStr.match(imgReg);
let img = []
let imgIndex = {}
let num = 0
if (!arr) return [
[],
[]
]
for (let i = 0; i < arr.length; i++) {
let src = arr[i].match(srcReg)
if (src && src[1]) {
img.push({
src: src[1],
})
imgIndex[src[1]] = num++
}
}
return [imgIndex, img]
},
imgPreview(e, that, data) {
if (e.target.nodeName == 'IMG') {
if (e.target.currentSrc && data[e.target.currentSrc] !== undefined) {
that.$refs.previewer.show(data[e.target.currentSrc])
}
} else if (e.target.nodeName == 'A') {
let url = e.target.getAttribute('data-href')
if (!url) {
return
}
if (url.indexOf('#') === 0) {
url = url.replace('#', '')
let anchor = document.querySelector('#' + url)
if (anchor) {
document.documentElement.scrollTop = anchor.offsetTop - 46
}
} else if (url.indexOf(that.$store.state.data.m_http) === 0) {
url = url.replace(that.$store.state.data.m_http, '')
url = url.replace('.html', '')
url = url.replace('.shtml', '')
return url
that.$router.push(url)
} else {
that._func.confirm(that, {
content: that.$t('go_thirdparty_url'),
confirmText: that.$t('now_go_to'),
cancelText: that.$t('hold_on'),
onConfirm() {
window.open(url, '_blank');
}
})
}
return
} else {
return
}
},
activated(that) {
let scrollTop = that.$route.meta.scrollTop
if (scrollTop) {
if (that.$route.meta.name) {
if (that.$route.meta.keepAlive) {
document.querySelector(that.$route.meta.name).scrollTop = scrollTop
} else {
setTimeout(function() {
document.querySelector(that.$route.meta.name).scrollTop = scrollTop
}, 500)
}
} else {
if (that.$route.meta.keepAlive) {
document.documentElement.scrollTop = scrollTop
} else {
setTimeout(function() {
document.documentElement.scrollTop = scrollTop
}, 500)
}
}
}
},
check_user_m(that) {
return new Promise((resolve, reject) => {
that.$store.commit('G_POSTCODE', null)
if (!that.$route.query.m) {
return resolve(true)
}
that._ajax.fetch('my/user/profile', {}, that, 0).then(res => {
if (res) {
if (res.info.check_mobile != 1 || res.info.mobile != that.$route.query.m) {
that._func.confirm(that, {
content: '支付账号和当前账号不一致？',
confirmText: '马上切换账号',
cancelText: that.$t('hold_on'),
onCancel() {
that.$router.push('/')
},
onConfirm() {
that._ajax.post_form('member/logout', '', that).then(res => {
if (res !== false) {
that.$store.commit('G_USERINFO', {})
that.token_conf.del(id)
that.$router.push('/member/login?m=' + that.$route.query.m + '&return=' + that.$route.fullPath)
}
})
}
})
return resolve(false)
}
}
return resolve(true)
})
})
},
$t(line, that, data) {
line = that.$t(line)
if (data || data == 0) {
if (Object.prototype.toString.call(data) === "[object Array]") {
for (var i = 0; i <= 4; i++) {
line = line.replace('{{' + i + '}}', data[i])
}
} else {
line = line.replace('{{}}', data)
line = line.replace('{{1}}', data)
}
}
return line
},
modal_open(val) {
if (val) {
document.querySelector('body').classList.add('vux-modal-open');
} else {
document.querySelector('body').classList.remove('vux-modal-open');
}
},
modal_static(val = '') {
if (val) {
document.querySelector('body').classList.add('vux-modal-static');
} else {
setTimeout(() => {
document.querySelector('body').classList.remove('vux-modal-static');
}, 400)
}
},
lgl_modal_open(val = true) {
if (val) {
document.querySelector('body').classList.add('lgl-modal-open');
} else {
document.querySelector('body').classList.remove('lgl-modal-open');
}
},
toast(line, that, data) {
that.$vux.toast.show({
text: this.$t(line, that, data),
width: 'auto',
position: 'middle',
type: 'text',
})
},
objArray(data) {
var arr = [];
for (var i in data) {
arr.push(data[i]);
}
return arr;
},
float(amount) {
return parseFloat(amount).toFixed(2);
},
float_str(amount) {
amount = parseFloat(amount);
amount = amount ? amount : 0;
return amount.toFixed(2);
},
arrayObj(data) {
var arr = {};
for (var i in data) {
arr[i] = data[i];
}
return arr;
},
objLen(obj) {
return Object.keys(obj).length
},
switchTop(top, body, header) {
if (!document.querySelector('.' + body)) return ''
let s_top = document.documentElement.scrollTop + document.body.scrollTop
let height = document.querySelector('.' + body).offsetHeight
let showHeader = false
if (s_top >= top) {
if (s_top >= top + height) {
document.querySelector('.' + header).classList.remove('top-view')
document.querySelector('.' + header+'-temp').classList.add('_hide')
showHeader = true
} else {
document.querySelector('.' + header).classList.add('top-view')
document.querySelector('.' + header+'-temp').classList.remove('_hide')
showHeader = false
}
} else {
document.querySelector('.' + header).classList.remove('top-view')
document.querySelector('.' + header+'-temp').classList.add('_hide')

if (s_top < top - 44) {
showHeader = true
}
}
return showHeader
},
setHtml(sys_info) {
if (sys_info.title) {
document.title = sys_info.title
}
if (sys_info.keyword) {
document.querySelector('meta[name="keywords"]').setAttribute('content', sys_info.keyword)
}else if (sys_info.keywords) {
document.querySelector('meta[name="keywords"]').setAttribute('content', sys_info.keywords)
}
if (sys_info.description) {
document.querySelector('meta[name="description"]').setAttribute('content', sys_info.description)
}
if (sys_info.icon) {
document.querySelector('link[rel="shortcut icon"]').setAttribute('href', sys_info.icon)
}
if (sys_info.app) {
document.querySelector('link[rel="apple-touch-icon"]').setAttribute('href', sys_info.app)
}
},
moveDistance(total, step_num = 25) {
total = total - 2
let distance = document.documentElement.scrollTop + document.body.scrollTop
let step = total / step_num
if (total > distance) {
smoothDown()
} else {
let newTotal = distance - total
step = newTotal / step_num
smoothUp()
}

function smoothDown() {
if (distance < total) {
distance += step
document.documentElement.scrollTop = document.body.scrollTop = distance
setTimeout(smoothDown, 10)
} else {
document.documentElement.scrollTop = document.body.scrollTop = total
}
}

function smoothUp() {
if (distance > total) {
distance -= step
document.documentElement.scrollTop = document.body.scrollTop = distance
setTimeout(smoothUp, 10)
} else {
document.documentElement.scrollTop = document.body.scrollTop = total
}
}
},
parseFloat(res) {
return {
lat: parseFloat(res.lat),
lng: parseFloat(res.lng),
};
},
removeHttp(url) {
if (url) {
url = url.replace('.html', '')
url = url.replace(/^.*\/\/[^\/]+/, '')
}
return url
},
empty(val) {
if (val == '' || val == undefined || val == null || val == '0' || val == 0) {
return true;
}
if (Object.prototype.toString.call(val) == "[object Object]" && Object.keys(val).length == 0) {
return true;
} else if (Object.prototype.toString.call(val) == "[object Array]" && val.length < 1) {
return true;
}
return false;
},
loading(that) {
return '<div class="loaders"><div class="loader-inner ball-clip-rotate-multiple"><div></div><div></div></div></div>' + that.$t('loading.submit');
},
get_count(data) {
if (!data) {
return 0
}
let length = typeof(data.length) == 'undefined' ? Object.keys(data).length : data.length;
return length;
},
MergeRecursive(obj1, obj2) {
for (var p in obj2) {
try {
if (obj2[p] && typeof obj2[p] === 'object') {
obj1[p] = this.MergeRecursive(obj1[p], obj2[p]);
} else if (Array.isArray(obj2[p])) {
obj1[p] = this.MergeRecursive(obj1[p], obj2[p]);
} else {
obj1[p] = obj2[p];
}
} catch (e) {
obj1[p] = obj2[p];
}
}
return obj1;
},
tour_url(data, all, url, durl) {
if (!this.empty(data)) {
let temp = []
let n = 0
for (var i in all.parame) {
temp[n] = all.parame[i].value
if(data == 'empty'){
temp[n] = ''
}else{
if (data.hasOwnProperty(all.parame[i].key)) {
if (Array.isArray(data[all.parame[i].key])) {
temp[n] = data[all.parame[i].key].join('_')
} else {
temp[n] = data[all.parame[i].key]
}
}
}

n++
}
temp[0] = 1
let path = all.url + temp.join('-')
if (!this.empty(url.query)) {
let n = 1
for (var i in url.query) {
if (n == 1) {
path += '?' + i + '=' + url.query[i]
} else {
path += '&' + i + '=' + url.query[i]
}
n++
}
}
return path
} else {
return durl
}
},
parseParams(query) {
var re = /([^&=]+)=?([^&]*)/g;
var decodeRE = /\+/g;
var decode = function(str) {
return decodeURIComponent(str.replace(decodeRE, " "));
};
var params = {},
e;
while (e = re.exec(query)) {
var k = decode(e[1]),
v = decode(e[2]);
if (k.substring(k.length - 2) === '[]') {
k = k.substring(0, k.length - 2);
(params[k] || (params[k] = [])).push(v);
} else params[k] = v;
}
return params;
},
sortId(a, b) {
return a.time - b.time
},
history(key, data = '_null_') {
var splits = '|||'
if (data != '_null_') {
var search_history = localStorage.getItem(key)
var temp = []
var news = []
if (search_history) {
temp = JSON.parse(search_history)
}
var flag = this.inArrayTitle(temp, data.title)
if (flag) {
temp.splice(flag - 1, 1)
}
data.time = new Date()
news[0] = data
if (temp.length > 11) {
temp.splice(temp.length - 1, 1)
}
temp = [...news, ...temp]
temp.sort(this.sortId)
localStorage.setItem(key, JSON.stringify(temp))
} else {
data = []
var search_history = localStorage.getItem(key)
if (search_history) {
data = JSON.parse(search_history)
}
return data
}
},
empty_history(key) {
localStorage.setItem(key, '')
},
storage(keyword) {
if (!keyword) return
keyword = md5(keyword)
let date = moment().format('YYYY-MM-DD')
if (localStorage[keyword] != date) {
localStorage[keyword] = date
return true
}
return false
},
changeStorage(keyword, op) {
if (!keyword) return
keyword = md5(keyword)
let date = moment().format('YYYY-MM-DD')
if (op) {
localStorage[keyword] = date
return
}
if (localStorage[keyword] != date) {
return true
}
return false
},
dataStorage(keyword, data) {
keyword = md5(keyword)
if (data == '__null__') {
localStorage.removeItem(keyword)
return ''
}
if (data) {
if (this.is_arr_obj(data)) {
data = JSON.stringify(data)
}
localStorage[keyword] = data
} else {
data = localStorage[keyword]
try {
data = JSON.parse(data)
} catch (err) {
data = {}
}
return data
}
},
strStorage(keyword, data) {
keyword = md5(keyword)
if (data == '__null__') {
localStorage.removeItem(keyword)
return ''
}
if (data) {
localStorage[keyword] = data
} else {
data = localStorage[keyword]
data = data ? data : ''
return data
}
},
inArrayTitle(arr, value) {
var i = arr.length;
while (i--) {
if (arr[i].title === value) {
return i + 1;
}
}
return false;
},
inArray(arr, value) {
if (!this.is_arr_obj(arr)) {
return false;
}
var i = arr.length;
while (i--) {
if (arr[i] === value) {
return true;
}
}
return false;
},
rmArray(arr, value) {
var i = arr.indexOf(value);
if (i != -1) {
arr.splice(i, 1);
}
return arr;
},
inObjKey(arr, value) {
var i = arr.length;
for (let i in arr) {
if (arr[i] === value) {
return i;
}
}
return '';
},
get_clor(id) {
id = parseInt(id);
var color = id % 4;
var list = ['primary', 'success', 'info', 'warning', 'danger'];
return list[color];
},
parse(data, type = 1) {
if (!data) return {}
if (type == 1) {
return JSON.parse(JSON.stringify(data))
}
},
is_date(data) {
if (data && data != '0000-00-00' && data != '0000-01-01') {
return true
} else {
return false
}
},
is_arr_obj(data) {
if (Object.prototype.toString.call(data) == "[object Array]" || Object.prototype.toString.call(data) == "[object Object]") {
return true
} else {
return false
}
},
parseParam(a) {
var s = [],
rbracket = /\[\]$/,
isArray = function(obj) {
return Object.prototype.toString.call(obj) === '[object Array]';
},
add = function(k, v) {
v = typeof v === 'function' ? v() : v === null ? '' : v === undefined ? '' : v;
s[s.length] = encodeURIComponent(k) + '=' + encodeURIComponent(v);
},
buildParams = function(prefix, obj) {
var i, len, key;
if (prefix) {
if (isArray(obj)) {
for (i = 0, len = obj.length; i < len; i++) {
if (rbracket.test(prefix)) {
add(prefix, obj[i]);
} else {
buildParams(prefix + '[' + (typeof obj[i] === 'object' ? i : '') + ']', obj[i]);
}
}
} else if (obj && String(obj) === '[object Object]') {
for (key in obj) {
buildParams(prefix + '[' + key + ']', obj[key]);
}
} else {
add(prefix, obj);
}
} else if (isArray(obj)) {
for (i = 0, len = obj.length; i < len; i++) {
add(obj[i].name, obj[i].value);
}
} else {
for (key in obj) {
buildParams(key, obj[key]);
}
}
return s;
};
return decodeURI(buildParams('', a).join('&').replace(/%20/g, '+'));
},
timer_to_html(intDiff, that, rm) {
that.setIndex = setInterval(function() {
var day = 0,
hour = 0,
minute = 0,
second = 0;
if (intDiff > 0) {
day = Math.floor(intDiff / (60 * 60 * 24));
hour = Math.floor(intDiff / (60 * 60)) - (day * 24);
minute = Math.floor(intDiff / 60) - (day * 24 * 60) - (hour * 60);
second = Math.floor(intDiff) - (day * 24 * 60 * 60) - (hour * 60 * 60) - (minute * 60);
if (hour <= 9) hour = '0' + hour;
if (minute <= 9) minute = '0' + minute;
if (second <= 9) second = '0' + second;
var day_html = day && day != '00' ? {
title: day,
unit: that.$t('day')
} : '';
var hour_html = hour && hour != '00' || day > 0 ? {
title: hour,
unit: ':'
} : '';
var minute_html = {
title: minute,
unit: ':'
};
var second_html = {
title: second,
unit: ''
};
var tobj = {
end: '',
day: day_html,
hour: hour_html,
minute: minute_html,
second: second_html
}
that.text = tobj
} else {
var tobj = {
end: {
title: that.$t('time_max_text')
}
}
that.text = tobj
}
intDiff--;
}, 1000);
},
_ajaxTabPage(that, data, pageDate, dataStatus, loading = true) {
if (!pageDate.conf.status) return new Promise(function(resolve, reject) {
resolve({
dataStatus: 2
})
})
let parame = JSON.parse(JSON.stringify(pageDate))
delete parame.conf
return new Promise(function(resolve, reject) {
that._ajax.page(pageDate.conf.ajax_url, parame, that, loading).then(res => {
let result = {}
pageDate.conf.load = true
if (res) {
let items
items = [...data, ...res.items]
if (items.length >= res.pages.total) {
pageDate.conf.status = false
dataStatus = 2
} else {
dataStatus = 1
}
pageDate.pageIndex = res.pages.nextpg
pageDate.pageSize = res.pages.pagesize
result = {
items: items,
dataStatus: dataStatus,
pageDate: pageDate
}
} else {
result = {
dataStatus: 3,
pageDate: pageDate
}
}
resolve(result)
})
})
},
post(url, params) {

this.posts(url, params);
},
posts(URL, PARAMTERS) {

var temp_form = document.createElement('form');
temp_form.action = URL;

temp_form.target = '_self';
temp_form.method = 'post';
temp_form.style.display = 'none';

for (var item in PARAMTERS) {
var opt = document.createElement('textarea');
opt.name = item;
opt.value = PARAMTERS[item];
temp_form.appendChild(opt);
}
document.getElementById('form-wrap').appendChild(temp_form);

temp_form.submit();
},
script_text(js_third_tmp) {
var x = document.createElement('script');
var t = document.createTextNode(js_third_tmp);
x.appendChild(t);
document.querySelector('#all-js-auto').appendChild(x)
},
script_include_text(encodedHtmlScript) {
if (!encodedHtmlScript) return;

const textarea = document.createElement('textarea');
textarea.innerHTML = encodedHtmlScript;
const decodedHTML = textarea.value;


const container = document.createElement('div');
container.innerHTML = decodedHTML;

const body = document.body;
const firstChild = body.firstChild;


const wrapper = document.createElement('div');
wrapper.id = 'third-js-wrapper';
wrapper.style.display = 'none'; 



container.querySelectorAll('script').forEach(oldScript => {
const script = document.createElement('script');


Array.from(oldScript.attributes).forEach(attr => {
script.setAttribute(attr.name, attr.value);
});


if (oldScript.textContent) {
script.textContent = oldScript.textContent;
}

wrapper.appendChild(script);
});


body.insertBefore(wrapper, firstChild);
},
script_iframe(js_third_tmp,m) {
if (process.env.NODE_ENV == 'app' || process.env.NODE_ENV == 'production') {
var ifr
for (var i in js_third_tmp) {
ifr = document.createElement('iframe');
ifr.src = js_third_tmp[i].url+'/localstorage.html';
ifr.style.display = 'none';
document.querySelector('#all-js-iframe').appendChild(ifr)
}
if(m){
ifr = document.createElement('iframe');
ifr.src = m+'/localstorage.html';
ifr.style.display = 'none';
document.querySelector('#all-js-iframe').appendChild(ifr)
}
}
},
loadScript(src, callback, id = 'js-wrap') {
this.arraySync(function(one, i, c) {
var cur_script = document.createElement('script');
cur_script.type = 'text/javascript';
cur_script.charset = 'UTF-8';
cur_script.src = one;
cur_script.addEventListener('load', function() {
c(0, {
i: i,
v: {}
});
}, false);
document.getElementById(id).appendChild(cur_script)
}, src, function(err, r) {

if (err) {
dhtmlxAlert(err.message);
} else {
callback && callback()
}
});
},
script() {
window.ReCaptchaLoaded = this.loaded;
var script = document.createElement('script');
script.src = 'https://www.google.com/recaptcha/api.js?onload=vueRecaptchaApiLoaded&render=explicit';
script.async = true;
script.defer = true;
document.head.appendChild(script);
},
onVerify(that, type) {
if (!that.data.g_recaptcha) return
let $this = this
if(that.data.captcha_type && that.data.captcha_type == 'turnstile'){
setTimeout(function() {
if (window.onloadTurnstileCallback === 'undefined') {
$this.onVerify(that, type);
} else {
window.onloadTurnstileCallback()

}
}, 100)
}else{
setTimeout(function() {
if (typeof that.$recaptcha === 'undefined') {
$this.onVerify(that, type);
} else {
$this.recaptchaLoad(that, type)
}
}, 100)
}
},
recaptchaLoad(that, type) {
if (type == 3) {
that.$recaptcha('').then((token) => {
that.formData['c-recaptcha-response'] = token
})
that.$recaptcha('').then((token) => {
that.formData['g-recaptcha-response'] = token
})
} else {
that.$recaptcha('').then((token) => {
if (type == 2) {
that.formData['c-recaptcha-response'] = token
} else {
that.formData['g-recaptcha-response'] = token
}
})
}
},
arraySync(bsFunc, ar) {
var callback = arguments[arguments.length - 1];
if (ar.length == 0) {
callback(0, []);
return;
}
var sendErr = false;
var finishNum = ar.length;
var result = [];
var args = [0, 0];
for (var index = 2; index < arguments.length - 1; ++index) {
args.push(arguments[index]);
}
args.push(function(err, r) {
if (err) {
if (!sendErr) {
sendErr = true;
callback(err);
}
return;
}
--finishNum;
result[r.i] = r.v;
if (finishNum == 0) {
callback(0, result);
}
});
for (var i = 0; i < ar.length; ++i) {
args[0] = ar[i];
args[1] = i;
bsFunc.apply(null, args);
}
},
platform() {
let platform = ''
let ua = navigator.userAgent.toLowerCase();
if (1 == 2 && ua.indexOf('micromessenger') !== -1) {
platform = 'wx'
} else if (ua.match(/android/i) == 'android') {
platform = 'android'
} else if (ua.match(/iPhone/i) == 'iPhone') {
platform = 'iPhone'
} else if (ua.match(/iPad/i) == 'iPad') {
platform = 'iPad'
}
return platform
},
thirdLogin(that, method, url) {
/*that.$vux.toast.show({
text: that.$t('label_redirect'),
type: 'success',
time: '10000',
isShowMask: true,
position: 'middle'
})*/

let domain = that.$store.state.data.m_http + '/member/access_token?'
let ref = that._func.strStorage('s_ref')
if (ref) {
url += '&ref=' + ref
}
url = that.$store.state.data.http + url + '&redirect=' + domain


window.location.href = url
},
setUrl(that, url) {
if(url){
return that.$store.state.data.m_http + url
}else{
return that.$store.state.data.m_http + that.$route.path
}
},
callPhone(number) {
if (!number) return
number = number.replace(/[ ,-]/g, '');
window.location.href = 'tel://' + number
},
copyText(that, text) {
if (!text) {
that.$vux.toast.show({
text: 'No content',
type: 'cancel'
})
return
}
that.$copyText(text).then(function(e) {
that.$vux.toast.show({
text: 'Copied',
})
}, function(e) {
that.$vux.toast.show({
text: 'Can not copy',
type: 'cancel'
})
})
},
setConf(that, wx_conf, f) {
let conf = {
debug: wx_conf.debug,
appId: wx_conf.appId,
timestamp: wx_conf.timestamp,
nonceStr: wx_conf.nonceStr,
signature: wx_conf.signature,
jsApiList: f
}
that.wx.config(conf)
that.wx.error(function(res) {
window.location.href = '/'

})
},
postcall( url, params, target){
var tempform = document.createElement("form");
tempform.action = url;
tempform.method = "post";
tempform.style.display="none"
if(target) {
tempform.target = target;
}
for (var x in params) {
var opt = document.createElement("input");
opt.name = x;
opt.value = params[x];
tempform.appendChild(opt);
}
var opt = document.createElement("input");
opt.type = "submit";
tempform.appendChild(opt);
document.body.appendChild(tempform);
tempform.submit();
document.body.removeChild(tempform);

},
wxShareTimeline(that, info) {
that.wx.ready((res) => {
that.wx.updateTimelineShareData({ // 分享给朋友  ,在config里面填写需要使用的JS接口列表，然后这个方法才可以用
title: info.title,
desc: info.description,
link: info.url,
imgUrl: info.img,
success: function() {},
cancel: function() {}
})
})
},
wxShareAppMessage(that, info) {
that.wx.ready((res) => {
that.wx.updateAppMessageShareData({
title: info.title,
desc: info.description,
link: info.url,
imgUrl: info.img,
success: () => {}
})
})
},
callMail(that, info,ext) {
if (!info || !info.title) return
let url = 'mailto:?subject=' + info.title + '&body=' + info.description
if(ext){
url += ext
}
window.location.href = url
},copyright(){
let PoweredBy = ""
PoweredBy += "=====================================\n"
PoweredBy += "Designed and Powered by Wesleyl\n"
PoweredBy += "Email - liangguilin5240@gmail.com\n"
PoweredBy += "Website - https://www.u-plus.ca\n"
PoweredBy += "=====================================\n"
console.log(PoweredBy)
}
}
